import React from 'react';
import PartialBlockPortalFactory from './PartialBlockPortalFactory';
import { IPartialBlockPortalList } from './IPartialBlockPortalList';

type PartialBlockPortalListProps = IPartialBlockPortalList & {
  ref: React.RefObject<HTMLDivElement | null>;
};

const PartialBlockPortalList: React.FC<PartialBlockPortalListProps> = ({
  partialBlocks,
  partialBlockSelector,
  partialBlockSelectorKeyPlaceHolder,
  replaceIdentifier,
  ref,
}) => {
  if (!partialBlocks) {
    return null;
  }

  const partialBlocksKeys = Object.keys(partialBlocks);
  if (!partialBlocksKeys || partialBlocksKeys.length === 0) {
    return null;
  }

  return (
    <>
      {partialBlocksKeys.map(key => (
        <PartialBlockPortalFactory
          key={key}
          identifier={key}
          partialBlocks={partialBlocks}
          partialBlockSelector={partialBlockSelector}
          partialBlockSelectorKeyPlaceHolder={partialBlockSelectorKeyPlaceHolder}
          replaceIdentifier={replaceIdentifier}
          ref={ref}
        />
      ))}
    </>
  );
};

export default PartialBlockPortalList;
